import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteSalesTax, getSalesTaxes } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const SalesTaxList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleSaleTaxes();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteSalesTax(id, { archive: true });
            if (data.success) handleSaleTaxes();
        } catch (err) { }
    };

    const handleSaleTaxes = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getSalesTaxes(params);
            const { resultsPerPage, totalCount, salesTax, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(salesTax.map(saleTax => {
                return {
                    type: saleTax?.isInclusive ? 'Inclusive' : 'Exclusive',
                    createdAt: saleTax.createdAt,
                    rate: saleTax?.rate || '',
                    name: saleTax.name || '',
                    _id: saleTax._id,
                }
            }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleSaleTaxes(page);
    };

    const AddPurchaseTax = () => navigate('/sales-tax/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_sale_taxes',
                        title: 'sale_tax_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleSaleTaxes,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                title: 'add_new_sale_tax',
                                className: 'btn btn-added',
                                action: AddPurchaseTax,
                                icon: 'plus',

                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleSaleTaxes} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                type="sales-tax"
                                noOfColumns={4}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SalesTaxList;